// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-container {
  width: 100%;
  max-width: 100%;
  height: 100vh;
  max-height: 100vh; /* Evitar overflow vertical */
  overflow: hidden !important; /* Sin scroll en el contenedor principal */
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: nowrap;
  overflow-x: hidden !important; /* Forzar sin scroll horizontal */
  overflow-y: hidden !important; /* Forzar sin scroll vertical */
  padding: 0; /* Sin padding para que el margen sea simétrico */
  margin: 0;
  background-color: #000;
  box-sizing: border-box;
  position: relative; /* Para contener elementos absolutos */
}

.white-background {
  padding-right: 0 !important;
}

.main-container.white-background .navbar-router-container {
  background-color: white !important;
  border-radius: 30px !important; /* Figma: 30px en las 4 esquinas */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important; /* Sombra como en oportunidades */
  margin: 15px !important; /* Mismo margen arriba y abajo (15px) */
}

/* Cuando el menú está colapsado, eliminar margen izquierdo del contenido */
.main-container.white-background .navbar-router-container.full-width {
  margin-left: 0 !important;
  padding: 0 !important;
  /* Altura: viewport menos márgenes (15px arriba + 15px abajo) */
  max-height: calc(
    100vh - 30px
  ) !important; /* 100vh - 15px - 15px = 30px */
  height: calc(
    100vh - 30px
  ) !important; /* Altura fija para que no haga overflow */
  overflow-y: hidden !important; /* El navbar-router-container NO scrollea: el scroll correcto vive en .scrollable-container */
  overflow-x: hidden !important;
}

.menu-desktop-container {
  width: 18rem; /* Default Expanded Width */
  padding: 0;
  min-height: 100vh;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: nowrap;
  overflow-x: hidden;
  flex-shrink: 0;
  box-sizing: border-box;
  background-color: #000;
  transition: width 0.3s ease; /* Smooth transition */
}

/* SLIM MODE (Collapsed) */
.menu-desktop-container.collapsed {
  width: 6rem;
}

.menu-movil-container {
  display: none;
}

.navbar-router-container {
  flex: 1; /* Take all remaining width */
  width: auto;
  min-width: 0;
  max-width: 100%;
  padding: 0;
  margin: 15px !important;
  height: calc(100vh - 30px); /* Full height minus margins */
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  transition: all 0.3s ease; /* Transition width/flex */
  box-sizing: border-box;
  overflow: hidden !important; /* No scroll on container */
  background: transparent !important; /* Transparent */
  border-radius: 0 !important;
  box-shadow: none !important;
}

/* 📏 CONTENIDO EXPANDIDO */
.navbar-router-container.full-width {
  /* Flex handles width, just ensuring margins are correct */
  margin: 15px !important;
  margin-left: 0 !important;
}

/* 🃏 CONTENT WRAPPER - The White Card */
.content-wrapper {
  width: 100%;
  flex: 1; /* Take remaining height */
  overflow-y: auto; /* Internal scroll */
  overflow-x: hidden;
  position: relative;
  border-radius: 30px; /* Increased roundness */
}

.content-wrapper.white-background {
  background-color: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 0;
  border-radius: 30px !important; /* Figma: 30px en las 4 esquinas */
  margin-bottom: 0 !important;
  height: 100%;
}

.navbar-router-container > * {
  width: 100%;
  box-sizing: border-box;
  flex-shrink: 0;
}

/* Override old styles */
.navbar-router-container.white-background {
  background: transparent !important;
  box-shadow: none !important;
}

/* Media query para resoluciones menores a 768px (Mobile range) */
@media (max-width: 767px) {
  .menu-desktop-container {
    display: none !important; /* Ocultar menú de escritorio */
  }

  .menu-movil-container {
    display: flex !important; /* Mostrar menú móvil */
    z-index: 2; /* Asegurar que el menú móvil esté por encima del navbar */
    position: absolute; /* El menú hamburguesa estará fijo en la parte superior */
    top: 0;
    right: 0;
    padding: 10px;
    background-color: #000;
  }

  .navbar-router-container,
  .navbar-router-container.full-width,
  .main-container.white-background .navbar-router-container,
  .main-container.white-background .navbar-router-container.full-width {
    /* Pegada a los bordes: todo el ancho, sin margen lateral ni inferior.
       Solo la franja superior (hamburguesa/metamask) queda en negro y la
       tarjeta blanca arranca con las 2 esquinas de arriba redondeadas. */
    width: 100vw !important;
    max-width: 100vw !important;
    padding: 0 !important;
    margin: 0 !important;
    margin-top: 68px !important; /* altura de la franja negra fija (.mobile-top-bar) */
    border-radius: 40px 40px 0 0 !important; /* solo esquinas superiores */
    box-shadow: none !important;
    max-height: calc(100dvh - 68px) !important;
    height: calc(100dvh - 68px) !important;
    z-index: 1;
    overflow-y: hidden !important;
    overflow-x: hidden !important;
  }

  /* Solo aplica fondo blanco a las vistas con white-background.
     /oportunidades y /administracion mantienen fondo transparente. */
  .main-container.white-background .navbar-router-container,
  .main-container.white-background .navbar-router-container.full-width {
    background-color: white !important;
  }

  .navbar-router-container:not(.white-background),
  .main-container:not(.white-background) .navbar-router-container {
    background-color: transparent !important;
    box-shadow: none !important;
  }

  .main-container {
    padding: 0 !important;
    height: 100dvh !important;
    max-height: 100dvh !important;
    width: 100% !important;
    max-width: 100vw !important;
    overflow: hidden !important;
    overflow-x: hidden !important;
    overflow-y: hidden !important;
  }
}

/* Media query para pantallas más pequeñas (menores a 500px) */
@media (max-width: 500px) {
  .main-container {
    padding: 0 !important;
    height: 100dvh !important;
    max-height: 100dvh !important;
    width: 100% !important;
    max-width: 100vw !important;
    overflow: hidden !important;
    overflow-x: hidden !important;
    overflow-y: hidden !important;
  }

  .menu-desktop-container {
    display: none;
  }

  .menu-movil-container {
    display: flex;
  }

  .navbar-router-container,
  .navbar-router-container.full-width,
  .main-container.white-background .navbar-router-container,
  .main-container.white-background .navbar-router-container.full-width {
    /* Pegada a los bordes, idéntico al breakpoint de 767px. */
    width: 100vw !important;
    max-width: 100vw !important;
    padding: 0 !important;
    margin: 0 !important;
    margin-top: 68px !important;
    max-height: calc(100dvh - 68px) !important;
    height: calc(100dvh - 68px) !important;
    border-radius: 40px 40px 0 0 !important;
    box-shadow: none !important;
    z-index: 1;
    overflow-y: hidden !important;
    overflow-x: hidden !important;
  }

  /* Solo aplica fondo blanco a las vistas con white-background.
     /oportunidades y /administracion mantienen fondo transparente. */
  .main-container.white-background .navbar-router-container,
  .main-container.white-background .navbar-router-container.full-width {
    background-color: white !important;
  }

  .main-container:not(.white-background) .navbar-router-container {
    background-color: transparent !important;
    box-shadow: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/components/main-container/main-container.component.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,eAAe;EACf,aAAa;EACb,iBAAiB,EAAE,6BAA6B;EAChD,2BAA2B,EAAE,0CAA0C;EACvE,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,iBAAiB;EACjB,6BAA6B,EAAE,iCAAiC;EAChE,6BAA6B,EAAE,+BAA+B;EAC9D,UAAU,EAAE,iDAAiD;EAC7D,SAAS;EACT,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB,EAAE,sCAAsC;AAC5D;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,8BAA8B,EAAE,kCAAkC;EAClE,mDAAmD,EAAE,iCAAiC;EACtF,uBAAuB,EAAE,uCAAuC;AAClE;;AAEA,2EAA2E;AAC3E;EACE,yBAAyB;EACzB,qBAAqB;EACrB,+DAA+D;EAC/D;;cAEY,EAAE,+BAA+B;EAC7C;;cAEY,EAAE,0CAA0C;EACxD,6BAA6B,EAAE,6FAA6F;EAC5H,6BAA6B;AAC/B;;AAEA;EACE,YAAY,EAAE,2BAA2B;EACzC,UAAU;EACV,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,sBAAsB;EACtB,2BAA2B,EAAE,sBAAsB;AACrD;;AAEA,0BAA0B;AAC1B;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,OAAO,EAAE,6BAA6B;EACtC,WAAW;EACX,YAAY;EACZ,eAAe;EACf,UAAU;EACV,uBAAuB;EACvB,0BAA0B,EAAE,8BAA8B;EAC1D,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,oBAAoB;EACpB,yBAAyB,EAAE,0BAA0B;EACrD,sBAAsB;EACtB,2BAA2B,EAAE,2BAA2B;EACxD,kCAAkC,EAAE,gBAAgB;EACpD,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA,2BAA2B;AAC3B;EACE,0DAA0D;EAC1D,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA,wCAAwC;AACxC;EACE,WAAW;EACX,OAAO,EAAE,0BAA0B;EACnC,gBAAgB,EAAE,oBAAoB;EACtC,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB,EAAE,wBAAwB;AAC/C;;AAEA;EACE,uBAAuB;EACvB,wCAAwC;EACxC,UAAU;EACV,8BAA8B,EAAE,kCAAkC;EAClE,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA,iEAAiE;AACjE;EACE;IACE,wBAAwB,EAAE,+BAA+B;EAC3D;;EAEA;IACE,wBAAwB,EAAE,uBAAuB;IACjD,UAAU,EAAE,0DAA0D;IACtE,kBAAkB,EAAE,yDAAyD;IAC7E,MAAM;IACN,QAAQ;IACR,aAAa;IACb,sBAAsB;EACxB;;EAEA;;;;IAIE;;yEAEqE;IACrE,uBAAuB;IACvB,2BAA2B;IAC3B,qBAAqB;IACrB,oBAAoB;IACpB,2BAA2B,EAAE,qDAAqD;IAClF,uCAAuC,EAAE,6BAA6B;IACtE,2BAA2B;IAC3B,0CAA0C;IAC1C,sCAAsC;IACtC,UAAU;IACV,6BAA6B;IAC7B,6BAA6B;EAC/B;;EAEA;qEACmE;EACnE;;IAEE,kCAAkC;EACpC;;EAEA;;IAEE,wCAAwC;IACxC,2BAA2B;EAC7B;;EAEA;IACE,qBAAqB;IACrB,yBAAyB;IACzB,6BAA6B;IAC7B,sBAAsB;IACtB,2BAA2B;IAC3B,2BAA2B;IAC3B,6BAA6B;IAC7B,6BAA6B;EAC/B;AACF;;AAEA,8DAA8D;AAC9D;EACE;IACE,qBAAqB;IACrB,yBAAyB;IACzB,6BAA6B;IAC7B,sBAAsB;IACtB,2BAA2B;IAC3B,2BAA2B;IAC3B,6BAA6B;IAC7B,6BAA6B;EAC/B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;;;;IAIE,0DAA0D;IAC1D,uBAAuB;IACvB,2BAA2B;IAC3B,qBAAqB;IACrB,oBAAoB;IACpB,2BAA2B;IAC3B,0CAA0C;IAC1C,sCAAsC;IACtC,uCAAuC;IACvC,2BAA2B;IAC3B,UAAU;IACV,6BAA6B;IAC7B,6BAA6B;EAC/B;;EAEA;qEACmE;EACnE;;IAEE,kCAAkC;EACpC;;EAEA;IACE,wCAAwC;IACxC,2BAA2B;EAC7B;AACF","sourcesContent":[".main-container {\n  width: 100%;\n  max-width: 100%;\n  height: 100vh;\n  max-height: 100vh; /* Evitar overflow vertical */\n  overflow: hidden !important; /* Sin scroll en el contenedor principal */\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  flex-wrap: nowrap;\n  overflow-x: hidden !important; /* Forzar sin scroll horizontal */\n  overflow-y: hidden !important; /* Forzar sin scroll vertical */\n  padding: 0; /* Sin padding para que el margen sea simétrico */\n  margin: 0;\n  background-color: #000;\n  box-sizing: border-box;\n  position: relative; /* Para contener elementos absolutos */\n}\n\n.white-background {\n  padding-right: 0 !important;\n}\n\n.main-container.white-background .navbar-router-container {\n  background-color: white !important;\n  border-radius: 30px !important; /* Figma: 30px en las 4 esquinas */\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important; /* Sombra como en oportunidades */\n  margin: 15px !important; /* Mismo margen arriba y abajo (15px) */\n}\n\n/* Cuando el menú está colapsado, eliminar margen izquierdo del contenido */\n.main-container.white-background .navbar-router-container.full-width {\n  margin-left: 0 !important;\n  padding: 0 !important;\n  /* Altura: viewport menos márgenes (15px arriba + 15px abajo) */\n  max-height: calc(\n    100vh - 30px\n  ) !important; /* 100vh - 15px - 15px = 30px */\n  height: calc(\n    100vh - 30px\n  ) !important; /* Altura fija para que no haga overflow */\n  overflow-y: hidden !important; /* El navbar-router-container NO scrollea: el scroll correcto vive en .scrollable-container */\n  overflow-x: hidden !important;\n}\n\n.menu-desktop-container {\n  width: 18rem; /* Default Expanded Width */\n  padding: 0;\n  min-height: 100vh;\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  flex-wrap: nowrap;\n  overflow-x: hidden;\n  flex-shrink: 0;\n  box-sizing: border-box;\n  background-color: #000;\n  transition: width 0.3s ease; /* Smooth transition */\n}\n\n/* SLIM MODE (Collapsed) */\n.menu-desktop-container.collapsed {\n  width: 6rem;\n}\n\n.menu-movil-container {\n  display: none;\n}\n\n.navbar-router-container {\n  flex: 1; /* Take all remaining width */\n  width: auto;\n  min-width: 0;\n  max-width: 100%;\n  padding: 0;\n  margin: 15px !important;\n  height: calc(100vh - 30px); /* Full height minus margins */\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: stretch;\n  transition: all 0.3s ease; /* Transition width/flex */\n  box-sizing: border-box;\n  overflow: hidden !important; /* No scroll on container */\n  background: transparent !important; /* Transparent */\n  border-radius: 0 !important;\n  box-shadow: none !important;\n}\n\n/* 📏 CONTENIDO EXPANDIDO */\n.navbar-router-container.full-width {\n  /* Flex handles width, just ensuring margins are correct */\n  margin: 15px !important;\n  margin-left: 0 !important;\n}\n\n/* 🃏 CONTENT WRAPPER - The White Card */\n.content-wrapper {\n  width: 100%;\n  flex: 1; /* Take remaining height */\n  overflow-y: auto; /* Internal scroll */\n  overflow-x: hidden;\n  position: relative;\n  border-radius: 30px; /* Increased roundness */\n}\n\n.content-wrapper.white-background {\n  background-color: white;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  padding: 0;\n  border-radius: 30px !important; /* Figma: 30px en las 4 esquinas */\n  margin-bottom: 0 !important;\n  height: 100%;\n}\n\n.navbar-router-container > * {\n  width: 100%;\n  box-sizing: border-box;\n  flex-shrink: 0;\n}\n\n/* Override old styles */\n.navbar-router-container.white-background {\n  background: transparent !important;\n  box-shadow: none !important;\n}\n\n/* Media query para resoluciones menores a 768px (Mobile range) */\n@media (max-width: 767px) {\n  .menu-desktop-container {\n    display: none !important; /* Ocultar menú de escritorio */\n  }\n\n  .menu-movil-container {\n    display: flex !important; /* Mostrar menú móvil */\n    z-index: 2; /* Asegurar que el menú móvil esté por encima del navbar */\n    position: absolute; /* El menú hamburguesa estará fijo en la parte superior */\n    top: 0;\n    right: 0;\n    padding: 10px;\n    background-color: #000;\n  }\n\n  .navbar-router-container,\n  .navbar-router-container.full-width,\n  .main-container.white-background .navbar-router-container,\n  .main-container.white-background .navbar-router-container.full-width {\n    /* Pegada a los bordes: todo el ancho, sin margen lateral ni inferior.\n       Solo la franja superior (hamburguesa/metamask) queda en negro y la\n       tarjeta blanca arranca con las 2 esquinas de arriba redondeadas. */\n    width: 100vw !important;\n    max-width: 100vw !important;\n    padding: 0 !important;\n    margin: 0 !important;\n    margin-top: 68px !important; /* altura de la franja negra fija (.mobile-top-bar) */\n    border-radius: 40px 40px 0 0 !important; /* solo esquinas superiores */\n    box-shadow: none !important;\n    max-height: calc(100dvh - 68px) !important;\n    height: calc(100dvh - 68px) !important;\n    z-index: 1;\n    overflow-y: hidden !important;\n    overflow-x: hidden !important;\n  }\n\n  /* Solo aplica fondo blanco a las vistas con white-background.\n     /oportunidades y /administracion mantienen fondo transparente. */\n  .main-container.white-background .navbar-router-container,\n  .main-container.white-background .navbar-router-container.full-width {\n    background-color: white !important;\n  }\n\n  .navbar-router-container:not(.white-background),\n  .main-container:not(.white-background) .navbar-router-container {\n    background-color: transparent !important;\n    box-shadow: none !important;\n  }\n\n  .main-container {\n    padding: 0 !important;\n    height: 100dvh !important;\n    max-height: 100dvh !important;\n    width: 100% !important;\n    max-width: 100vw !important;\n    overflow: hidden !important;\n    overflow-x: hidden !important;\n    overflow-y: hidden !important;\n  }\n}\n\n/* Media query para pantallas más pequeñas (menores a 500px) */\n@media (max-width: 500px) {\n  .main-container {\n    padding: 0 !important;\n    height: 100dvh !important;\n    max-height: 100dvh !important;\n    width: 100% !important;\n    max-width: 100vw !important;\n    overflow: hidden !important;\n    overflow-x: hidden !important;\n    overflow-y: hidden !important;\n  }\n\n  .menu-desktop-container {\n    display: none;\n  }\n\n  .menu-movil-container {\n    display: flex;\n  }\n\n  .navbar-router-container,\n  .navbar-router-container.full-width,\n  .main-container.white-background .navbar-router-container,\n  .main-container.white-background .navbar-router-container.full-width {\n    /* Pegada a los bordes, idéntico al breakpoint de 767px. */\n    width: 100vw !important;\n    max-width: 100vw !important;\n    padding: 0 !important;\n    margin: 0 !important;\n    margin-top: 68px !important;\n    max-height: calc(100dvh - 68px) !important;\n    height: calc(100dvh - 68px) !important;\n    border-radius: 40px 40px 0 0 !important;\n    box-shadow: none !important;\n    z-index: 1;\n    overflow-y: hidden !important;\n    overflow-x: hidden !important;\n  }\n\n  /* Solo aplica fondo blanco a las vistas con white-background.\n     /oportunidades y /administracion mantienen fondo transparente. */\n  .main-container.white-background .navbar-router-container,\n  .main-container.white-background .navbar-router-container.full-width {\n    background-color: white !important;\n  }\n\n  .main-container:not(.white-background) .navbar-router-container {\n    background-color: transparent !important;\n    box-shadow: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
